export const REPORTS_NO_RESULT_TITLE = 'No reports to show';
export const REPORTS_DETAILS_NO_RESULT_TITLE = 'No report details to show';
export const REPORTS_NO_RESULT_SUBTITLE = 'Change your filters and try again.';
export const labelMapping = {
  past30Days: 'in the past 30 days',
  past90Days: 'in the past 90 days',
  thisMonth: 'in this month',
  lastMonth: 'in the last month',
  thisYear: 'in this year',
  lastYear: 'in the last year',
  custom: 'in the selected period'
};
export const countKey = {
  sales: 'revenue',
  evaluations: 'evaluations',
  feedback: 'feedbackCount',
  conversions: 'value',
  renewals: 'value',
  churn: 'value'
};
export const SIDE_NAV_MIN_WIDTH = 240;
export const DEFAULT_OVERVIEW_CARDS_COUNT = 5;
export const REPORTS_CONTENT_WIDTH = 974;

// partnerDetails is not returned when sales channel is Direct
export const SALES_CHANNELS = {
  Expert: 'Sold by expert',
  Reseller: 'Sold by Reseller'
};
export const EMPTY_STATE = '-';